export const MAX_PERSISTENT_MENU_ITEMS_COUNT = 10;

export const MAX_CALL_TO_ACTION_ITEMS_COUNT = 3;

// * Largest page size the conversation lists may request. Enforced in Core as
// * well as in the UI: the two must agree, because the page count is computed
// * from the caller's own page size. A UI that asks for more than Core returns
// * would draw too few pages and leave the surplus records unreachable.
export const MAX_CONVERSATION_PAGE_SIZE = 1000;
